import React, { useEffect } from "react";
import { useToast } from "@/components/ui/use-toast";

const RegistrationToast = ({
  isAuthLoading,
  isAuthenticated,
  user,
  fromRegistration,
  currentSubscription,
}) => {
  const { toast } = useToast();

  useEffect(() => {
    // Only prompt to select a plan when the user has truly never picked one.
    // Sellers on the free plan (no subscription object) are valid — don't nag them.
    // Only show when: newly registered seller who hasn't chosen anything AND
    // arrived here NOT via the registration flow (which already shows the plans).
    const hasNoPlan = !user?.membership?.plan && !currentSubscription;
    if (
      !isAuthLoading &&
      isAuthenticated &&
      user?.role === "seller" &&
      hasNoPlan &&
      !fromRegistration
    ) {
      toast({
        title: "Please select a plan",
        description:
          "To access your dashboard, you need to select a membership plan.",
        variant: "default",
        duration: 5000,
      });
    }
  }, [
    isAuthenticated,
    user,
    isAuthLoading,
    fromRegistration,
    currentSubscription,
    toast,
  ]);

  return null;
};

export default RegistrationToast;
